import { Phone, MessageCircle, Navigation, MapPin } from "lucide-react";
import { CLINIC } from "../../data/content";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const Contact = () => (
    <section id="contact" data-testid="contact-section" className="py-24 lg:py-32">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-2 lg:gap-16 lg:px-10">
            <div>
                <SectionHeading
                    number="09"
                    eyebrow="Contact"
                    title="Visit Us in"
                    accent="Kasba, Kolkata"
                />
                <Reveal delay={0.15}>
                    <div className="mt-10 rounded-3xl border border-ink/10 bg-white p-8">
                        <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-teal-accent">
                            <MapPin className="h-4 w-4" /> {CLINIC.name}
                        </p>
                        <p data-testid="contact-address" className="mt-4 font-display text-2xl font-light leading-relaxed text-ink">
                            {CLINIC.addressLines.map((line, i) => (
                                <span key={i} className="block">
                                    {line}
                                </span>
                            ))}
                        </p>
                        <p className="mt-5 text-sm font-bold text-slate-600">
                            Phone:{" "}
                            <a data-testid="contact-phone-link" href={`tel:${CLINIC.phoneTel}`} className="text-teal-700 underline decoration-teal-500/40 underline-offset-4 hover:text-teal-600">
                                {CLINIC.phoneDisplay}
                            </a>
                        </p>
                        <div className="mt-7 flex flex-wrap gap-3">
                            <a
                                data-testid="contact-call-btn"
                                href={`tel:${CLINIC.phoneTel}`}
                                className="inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm font-bold text-[#f8f6f0] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-teal-700"
                            >
                                <Phone className="h-4 w-4" /> Call Clinic
                            </a>
                            <button
                                data-testid="contact-whatsapp-btn"
                                className="inline-flex items-center gap-2 rounded-full bg-teal-accent px-6 py-3.5 text-sm font-bold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-teal-700"
                            >
                                <MessageCircle className="h-4 w-4" /> WhatsApp
                            </button>
                            <a
                                data-testid="contact-directions-btn"
                                href={CLINIC.mapsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 rounded-full border border-ink/20 px-6 py-3.5 text-sm font-bold text-ink transition-[border-color,background-color,transform] duration-300 hover:-translate-y-0.5 hover:border-teal-600 hover:bg-mist"
                            >
                                <Navigation className="h-4 w-4 text-teal-accent" /> Get Directions
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
            <Reveal delay={0.2} className="min-h-[24rem]">
                <div className="h-full overflow-hidden rounded-3xl border border-ink/10 shadow-[0_30px_60px_-30px_rgba(11,31,42,0.3)]">
                    <iframe
                        data-testid="contact-map"
                        title="Smile Dental Clinic location map — Kasba, Kolkata"
                        src={CLINIC.mapEmbed}
                        className="h-full min-h-[24rem] w-full grayscale-[30%] transition-[filter] duration-700 hover:grayscale-0"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                    />
                </div>
            </Reveal>
        </div>
    </section>
);
